<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { cn } from "@/lib/utils";

interface Props extends /* @vue-ignore */ HTMLAttributes {
  class?: HTMLAttributes["class"];
}

const props = defineProps<Props>();
</script>

<template>
  <span :class="cn('font-mono', props.class)" v-bind="{ ...props, ...$attrs }">
    <slot />
  </span>
</template>
